import {Link} from 'react-router';

import {dataTableActionT, dataTableColumnT} from '@/lib/types/dataTable.types';
import {productT} from '@/lib/types/product.types';

export const renderProductTableStats = (
  totalProducts: number | undefined | null,
  activeProducts: number | undefined | null,
  inactiveProducts: number | undefined | null
) => [
  {
    title: 'Total Products',
    value: totalProducts,
    subtitle: 'This Month',
    change: 1.03,
    icon: 'ri-price-tag-3-line',
    color: 'primary',
    cardClass: 'bg-primary/10 text-primary',
  },
  {
    title: 'Active Products',
    value: activeProducts,
    subtitle: 'This Month',
    change: 0.36,
    icon: 'ri-check-line',
    color: 'secondary',
    cardClass: 'bg-secondary/10 text-secondary',
  },
  {
    title: 'Inactive Products',
    value: inactiveProducts,
    subtitle: 'This Month',
    change: -1.28,
    icon: 'ri-close-line',
    color: 'warning',
    cardClass: 'bg-warning/10 text-warning',
  },
];

export const productColumns: dataTableColumnT<'Product'>[] = [
  {
    header: 'Name',
    field: 'product_name',
    render: (product: productT) => (
      <Link to={`/products/${product.product_id}`} className="text-primary hover:text-primary dark:text-primary">
        {product.product_name}
      </Link>
    ),
  },
  {
    header: 'Status',
    field: 'product_is_active',
    render: (product: productT) => (
      <span className={`badge bg-${!product.date_removed ? 'success' : 'danger'} text-white`}>
        {!product.date_removed ? 'Active' : 'Inactive'}
      </span>
    ),
  },
  {header: 'Category', field: 'product_category'},
  {header: 'Sub Category', field: 'product_subcategory'},
  {header: 'Strain Type', field: 'product_strain'},
];

export const productActions = (
  isAdmin: boolean,
  handleEditProductClick: (row: productT) => void,
  handleDeleteProductClick: (row: productT) => void
): dataTableActionT<'Product'>[] => [
  {
    icon: 'ri-pencil-line',
    color: 'info',
    handler: handleEditProductClick,
    permission: () => isAdmin,
  },
  {
    icon: 'ri-delete-bin-line',
    color: 'danger',
    handler: handleDeleteProductClick,
    permission: () => isAdmin,
  },
];
